import { createContext } from "react"

export const UserContext = createContext({
    parcelID: "",
    name: "",
    email: "",
    user_is_homestead: false,
    parcelHasHxCode: false,
    bypassResidencyDueToApplication: false,
    selectedExemptions: [],
    situsAddress: ""
})